import { cn } from "@/lib/utils";

import { type CommodityListItem } from "./types";

export const DEFAULT_PAGE_SIZE = 20;
export const NUMBER_COLUMN_WIDTH_CLASS = "max-w-32";
// Wider than NUMBER_COLUMN_WIDTH_CLASS so multi-word headers can wrap without overlapping.
export const METRIC_HEADER_WIDTH_CLASS = "min-w-32 max-w-44";

export const COMPACT_HEADER_CLASS = "px-3 py-2 !whitespace-normal leading-tight";
export const NUMERIC_HEADER_CLASS = cn(COMPACT_HEADER_CLASS, "text-right");
export const WRAPPING_HEADER_LABEL_CLASS = "block whitespace-normal wrap-break-word leading-tight";

export const SEARCHABLE_COMMODITY_FIELDS = [
  "name",
] as const satisfies readonly (keyof CommodityListItem)[];

// Sortable country-overview columns, in table order. `id` matches the column id so the sort
// dropdown and the column-header sorting drive the same TanStack sorting state.
export const COMMODITY_SORT_OPTIONS = [
  { id: "commodity", translationKey: "commodities.list.column.commodity" },
  { id: "farmersWithCommodity", translationKey: "commodities.list.column.farmersWithCommodity" },
  { id: "sumOfLandSize", translationKey: "commodities.list.column.sumOfLandSize" },
  { id: "averageLandSize", translationKey: "commodities.list.column.averageLandSize" },
  { id: "depositsAtAggregator", translationKey: "commodities.list.column.depositsAtAggregator" },
  { id: "quantityDeposited", translationKey: "commodities.list.column.quantityDeposited" },
  { id: "quantitySold", translationKey: "commodities.list.column.quantitySold" },
  { id: "harvestsByFarmer", translationKey: "commodities.list.column.harvestsByFarmer" },
  { id: "quantityHarvested", translationKey: "commodities.list.column.quantityHarvested" },
  { id: "events", translationKey: "commodities.list.column.events" },
] as const;
